import $ from 'jquery';
import jsCookie from 'js-cookie';
import Loader from './loader';

class CCform {

  constructor(form) {
    this.$form = $(form);
    this.action = this.$form.attr('action');
    this.method = this.$form.attr('method') || 'GET';
    this.loader = new Loader(this.$form);
    this.hasCaptcha = false;
    this.msgType = {
      error: 'error',
      info: 'info',
    };
    this.$captchaWrapper = this.$form.find('li.captcha');
    if (this.$captchaWrapper.length) {
      this.captcha = {};
      this.hasCaptcha = true;
    }
    this.$submitRow = $('li.submit');
  }

  init() {
    if (this.hasCaptcha) {
      this.captcha.$hidden = this.$captchaWrapper.find('input[type=hidden]').first();
      this.captcha.$input = this.$captchaWrapper.find('input[type=text]').first();
      this.$csrf = this.$form.find('input[name="csrfmiddlewaretoken"]');

      this.captchaAddReloader();
    }

    this.makeCustomCheckbox();
    this.setEvents();
    this.token();
    this.reloadCaptcha();
  }

  reloadCaptcha() {
    if (this.hasCaptcha && this.captcha.$reload && this.captcha.$reload.length) {
      this.captcha.$reload.trigger('click.captcha');
    }
  }

  makeCustomCheckbox() {
    const $inputCheckbox = this.$form.find('input[type=checkbox]');

    $inputCheckbox.parent().contents().filter(function () {
      return this.nodeType === 3;
    })
      .wrap('<span class="checkbox-label-text"></span>');

    $inputCheckbox.addClass('visually-hidden')
      .after('<span class="checkbox-fake"></span>');
  }

  setEvents() {
    this.$form.on('click', '.agreement-show-info', e => {
      const $parent = $(e.target).parents('label');
      const $checkbox = $parent.find('.checkbox-label-text');
      const newText = $parent.parent().find('div.hidden .agreement').html();
      const showButton = $parent.find('.agreement-show-info');

      $checkbox.html(newText);
      showButton.hide();
    });

    this.$form.on('submit', e => {
      e.preventDefault();
      this.loader.show();
      this.removeErrors();

      const field = $('#id_phone');
      let val = field.val();

      if (val && /\d+/.test(val)) {
        val = val.match(/\d+/g).join('').match(/(\d{3})(\d{3})(\d{3})/);
        if (val && val.length && val.length === 4) {
          field.val(val.slice(1).join('-'));
        }
      }

      this.submit()
        .done(res => {
          this.res = res;
          this.submitSuccess();
        })
        .error(() => {
          this.submitError();
        })
        .always(() => {
          this.submitAlways();
        });
    });

    if (this.hasCaptcha) {
      this.captcha.$reload.on('click.captcha', e => {
        e.preventDefault();
        this.loader.show();
        this.captchaGetNew()
          .done(res => {
            this.captchaGetSuccess(res);
          })
          .always(() => {
            this.captchaGetAlways();
          });
      });
    }
  }

  handleErrorMessagess() {
    if (this.res.message) {
      this.$submitRow.prepend(`<p class="error-message">${this.res.message}</p>`);
    }
    if (this.res.title) {
      this.$submitRow.prepend(`<p class="error-message">${this.res.title}</p>`);
    }
  }

  handleSuccessMessages() {
    if (this.res.title) {
      this.$form.before(`<p class="info-message">${this.res.title}</p>`);
    }
    if (this.res.message) {
      this.$form.before(`<p class="info-message">${this.res.message}</p>`);
    }
  }

  /* eslint-disable no-underscore-dangle */
  handleAllErrors() {
    this.res.errors.__all__.forEach(error => {
      this.$submitRow.prepend(`<p class="error-message">${error}</p>`);
    });
  }

  /* eslint-enable no-underscore-dangle */

  handleNormalErrors() {
    for (const field in this.res.errors) {
      if (Object.prototype.hasOwnProperty.call(this.res.errors, field)) {
        const $target = this.$form.find(`li.${field}`);
        const errors = this.res.errors[field];

        for (let i = 0, len = errors.length; i < len; i++) {
          $target
            .addClass('error')
            .append(`<p class="error-message">${errors[i]}</p>`);
        }
      }
    }
  }

  /* eslint-disable no-underscore-dangle */
  submitSuccess() {
    if (this.res.captcha && this.hasCaptcha) {
      this.captchaGetSuccess(this.res.captcha[0]);
    } else {
      this.reloadCaptcha();
    }

    if (this.res.valid) {
      this.handleSuccessMessages();
      if (this.res.clearform) {
        this.removeForm();
      }
    } else if (this.res.errors.__all__) {
      this.handleAllErrors();
    } else {
      this.handleNormalErrors();
      this.handleErrorMessagess();
    }
  }

  /* eslint-enable no-underscore-dangle */

  submitError() {
    this.$submitRow.prepend('<p class="error-message">Wystąpił błąd. Spróbuj ponownie później</p>');
  }

  submitAlways() {
    this.loader.remove();
  }

  clearForm() {
    this.$form.find('input[type=text], textarea').val('');
    this.$form.find('input[type=checkbox]').prop('checked', false);
  }

  removeForm() {
    this.$form.remove();
  }

  submit() {
    return $.ajax({
      url: this.action,
      type: this.method,
      data: this.$form.serialize(),
    });
  }

  removeErrors() {
    this.$form.find('p.error-message').remove();
    this.$form.find('p.info-message').remove();
    this.$form.find('li.error').removeClass('error');
  }

  captchaGetNew() {
    return $.ajax({
      url: '/_ajax/ccforms/captcha_load/',
      type: 'GET',
      cache: false,
      data: `${this.$csrf.attr('name')}=${this.$csrf.val()}`,
    });
  }

  captchaGetSuccess(res) {
    this.captcha.$img.attr('src', res.image);
    this.captcha.$hidden.val(res.key);
  }

  captchaGetAlways() {
    this.loader.remove();
  }

  captchaAddReloader() {
    this.captcha.$img = this.$form.find('img.captcha');
    // eslint-disable-next-line max-len
    this.captcha.$reload = $('<button class="captcha-reload" title="Przeładuj obrazek"><svg role="img"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/static/dist-tracked/front/iko-app-lite/symbol/svg/sprite.symbol.svg#reload"></use></svg></button>');
    this.captcha.$img.after(this.captcha.$reload);
  }

  static randomString() {
    let text = '';
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    for (let i = 0; i < 64; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return text;
  }

  token() {
    const cookieVal = jsCookie.get('csrftoken');

    if (typeof cookieVal !== 'string' || typeof cookieVal === 'string' && cookieVal.length !== 64) {
      const csrftoken = CCform.randomString();

      jsCookie.set('csrftoken', csrftoken, { expires: 3, path: '/' });

      if (this.$form.find('input[name=csrfmiddlewaretoken]').length) {
        this.$form.find('input[name=csrfmiddlewaretoken]').remove();
      }

      this.$form
        .append(`<input type="hidden" name="csrfmiddlewaretoken" value=${jsCookie.get('csrftoken')}>`).val(csrftoken);
    } else if (typeof cookieVal === 'string') {
      if (this.$form.find('input[name=csrfmiddlewaretoken]').length) {
        this.$form.find('input[name=csrfmiddlewaretoken]').remove();
      }
      this.$form.append(`<input type="hidden" name="csrfmiddlewaretoken" value=${jsCookie.get('csrftoken')}>`);
    }
  }

}

export default CCform;



// WEBPACK FOOTER //
// ./front/iko-app-lite/js/app/ccforms.js